export const getAvatarCategoryName = (page: number) =>
  page < 3
    ? 'Classique ' + (page + 1)
    : page < 6
    ? 'Bronze ' + (page - 2)
    : page < 9
    ? 'Argent ' + (page - 5)
    : page < 12
    ? 'Or ' + (page - 8)
    : 'Halloween ' + (page - 11);
